/// <amd-module name="SuiteCommerce.GridOrder.Row.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GridOrder.Row.Collection", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var RowCollection = /** @class */ (function (_super) {
        __extends(RowCollection, _super);
        function RowCollection() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        RowCollection.prototype.getLinesForCart = function () {
            var lines = [];
            this.each(function (row) {
                row.cellsCollection.each(function (cell) {
                    var quantity = cell.quantity;
                    if (quantity > 0) {
                        var line = {
                            quantity: quantity,
                            item: {
                                internalid: cell.internalId,
                            },
                        };
                        lines.push(line);
                    }
                });
            });
            return lines;
        };
        return RowCollection;
    }(Backbone_1.Collection));
    exports.RowCollection = RowCollection;
});
